import axios, { AxiosResponse } from 'axios';
import { ApiResponse, zps_ea_war } from '../zps';
import { MeansCash } from '../transactions';
import { handleDownload } from '../../app/utils/script';

// User Summary
export interface IUserSummary {
  entid: number;
  uid: number;
  name: string;
  lastOperationEid: number;
  lastOperation: string;
  lastOperationDt: string;
  lastOperationValue: number;
  cid: number;
  balance: number;
}

export interface IUserSummariesResponse extends ApiResponse {
  list: IUserSummary[];
  totalRows: number;
  type: string;
}

export interface IUserSummariesReportResponse extends ApiResponse {
  format: string;
  mime: string;
  name: string;
  report: string;
  type: string;
}

export interface IUserSummaryRequest {
  eid: number;
  entid: number;
  incOrSet: boolean;
  uid: number;
  value: number;
}

export const fetchUsersSummaries = (
  entid: number,
  offset: number,
  limit: number,
  totalRows: boolean,
  uid?: number,
  balance?: boolean
): Promise<AxiosResponse<IUserSummariesResponse>> => {
  return axios.get<IUserSummariesResponse>(
    `${zps_ea_war}/tb401/transaction/user/?entid=${entid}&offset=${offset}&limit=${limit}&totalRows=${totalRows}` +
      `${uid ? `&uid=${uid}` : ''}` +
      `${balance ? `&balance=${balance}` : ''}`
  );
};

export const fetchUserSummaryDetails = (
  entid: number,
  uid: number,
  eid: number
): Promise<AxiosResponse<IUserSummariesResponse>> => {
  return axios.get<IUserSummariesResponse>(
    `${zps_ea_war}/tb401/transaction/user/?entid=${entid}&uid=${uid}&eid=${eid}`
  );
};
export const updateUserSummary = (
  request: IUserSummaryRequest,
  controller: AbortController
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.post<ApiResponse>(`${zps_ea_war}/tb401/transaction/user`, request, { signal: controller.signal });
};

export const fetchUserSummaryXLSReport = (
  entid: number,
  controller: AbortController,
  balance?: boolean
): Promise<AxiosResponse<IUserSummariesReportResponse>> => {
  return axios
    .get<IUserSummariesReportResponse>(
      `${zps_ea_war}/tb401/transaction/user/report?entid=${entid}&format=xls` +
        `${balance ? `&balance=${balance}` : ''}`,
      { signal: controller.signal }
    )
    .then(response => {
      const data = response.data;
      handleDownload(data.report, data.name, data.mime);
      return response;
    });
};
// Withdraw Set
export interface IWithdrawSets {
  description: string;
  entid: number;
  gid: number;
  id: number;
  inUse: number;
  mc: MeansCash[];
}

export interface IWithdrawSetRequest {
  description: string;
  entid: number;
  id: number;
  mc: MeansCash[];
}

export interface IWithdrawSetsResponse extends ApiResponse {
  list: IWithdrawSets[];
  totalRows: number;
  type: string;
}

export const fetchWithdrawSets = (
  entid: number,
  controller: AbortController
): Promise<AxiosResponse<IWithdrawSetsResponse>> => {
  return axios.get<IWithdrawSetsResponse>(`${zps_ea_war}/withdrawalset/?entid=${entid}`, { signal: controller.signal });
};

export const fetchWithdrawSetDetails = (entid: number, id: number): Promise<AxiosResponse<IWithdrawSetsResponse>> => {
  return axios.get<IWithdrawSetsResponse>(`${zps_ea_war}/withdrawalset/?entid=${entid}&id=${id}`);
};

export const addWithdrawSetDetails = (entid: number, id: number): Promise<AxiosResponse<ApiResponse>> => {
  return axios.post<ApiResponse>(`${zps_ea_war}/withdrawalset`, { entid, id });
};
export const updateWithdrawSetDetails = (
  request: IWithdrawSetRequest,
  controller: AbortController
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.put<ApiResponse>(`${zps_ea_war}/withdrawalset`, request, { signal: controller.signal });
};

export const deleteWithdrawSetDetails = (entid: number, id: number): Promise<AxiosResponse<ApiResponse>> => {
  return axios.delete<ApiResponse>(`${zps_ea_war}/withdrawalset/?entid=${entid}&id=${id}`);
};
